<template>
  <div class="video_tutorial_warp english_container " id="specific-position" style="position: relative;">
    <myHeader></myHeader>
    <div class="titie_tap">
      <p class="title enProductTitle">hecoos tutorial videos</p>
      <div class="tab">
        <span :class="{ active: currentTab === 'function' }" @click="changeTab('function')">
          Function Section
        </span>
        <span :class="{ active: currentTab === 'application' }" @click="changeTab('application')">
          Application Section
        </span>
        <span :class="{ active: currentTab === 'xR' }" @click="changeTab('xR')">
          xR/VP
        </span>
      </div>
    </div>
    <div class="video_tutorial_content">
      <div class="content" v-if="list.length">
        <div class="content_list">
          <div v-for="(item, index) in list" class="content_item" :key="item.id">
            <div class="item_top">
              <img :src="baseUrl + item.cover" alt="" />
              <p class="view_count">View count:{{ item.view_num }}</p>
              <div class="play" @click="pageTransition(item)">
                <div class="play_icon">
                </div>
              </div>
            </div>
            <div class="item_bottom">
              <p class="item_describe" v-html="item.title"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="no_data" v-else>No data available yet!!!</div>
    </div>
    <myFooter></myFooter>
    <BackToTop />
    <!-- 视频详情组件 -->
    <div class="video_detail" v-if="VideoDetailsIsShow" @click.self="closeDetail">
      <button class="video_close" @click="closeDetail">&times;</button>
      <div class="video_detail_content">
        <div class="content_top">
          <div class="content_top_left">
            <video :src="videoDetailMsg.youtube" autoplay controls muted></video>
          </div>
          <div class="content_top_right">
            <div class="content_top_r_item" v-for="videoItem in videoList">
              <div class="item_img">
                <img :src="baseUrl + videoItem.cover" alt="">
                <div class="video_play" @click="pageTransition(videoItem)">
                  <div class="video_play_icon">
                  </div>
                </div>
              </div>
              <p class="ellipsis-text" v-html="videoItem.title"></p>
            </div>
          </div>
        </div>
        <div class="content_bottom">
          <div class="content_bottom_text">
            <h2 v-html="videoDetailMsg.title"></h2>
            <p v-html="videoDetailMsg.describe"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader";
import myFooter from "@/components/en_pc/myFooter";
import BackToTop from "@/components/pc/BackToTop";
import { getVideoList } from "@/api/api";
export default {
  data() {
    return {
      baseUrl: "https://www.hecoos.com/",
      functionList: [],
      applicationList: [],
      xRList: [],
      list: [],
      VideoDetailsIsShow: false,
      videoDetailMsg: {},
      videoList: {},
      currentTab: "function", // 新增变量，记录当前选中的 tab
    };
  },
  components: { myHeader, myFooter, BackToTop },
  created() {
    this.getVideoLists();
  },
  methods: {
    // 获取视频数据
    getVideoLists() {
      getVideoList().then((res) => {
        this.functionList = res.data.functionList || [];
        this.list = this.functionList;
        this.videoList = this.list;
        this.applicationList = res.data.applicationList || [];
        this.xRList = res.data.xrList || [];
      });
    },
    // 数据清洗
    changeTab(tab) {
      this.currentTab = tab;
      if (tab === 'function') {
        this.list = this.functionList;
      } else if (tab === 'application') {
        this.list = this.applicationList;
      } else {
        this.list = this.xRList;
      }
      this.videoList = this.list;
    },
    pageTransition(item) {
      // console.log(111111111111111111);
      if (item && item.youtube) {
        this.videoDetailMsg = item;
        this.VideoDetailsIsShow = true;
        // 根据视频详情组件的显示状态来控制页面的滚动条
        // 如果VideoDetailsIsShow为true（即视频详情组件显示），则禁止页面滑动
        // 如果为false（即视频详情组件隐藏），则恢复页面的正常滑动
        this.VideoDetailsIsShow ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';
      } else {
        console.error("item is undefined or does not have a link property");
      }
    },
    closeDetail() {
      // 将视频详情组件的显示状态设置为隐藏
      this.VideoDetailsIsShow = false;
      // 恢复页面的正常滑动
      document.body.style.overflow = 'auto';
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";
@import "@/styles/optimize_adaptation.scss";
</style>
